(function (angular) {
	'use strict';

	angular
		.module('baseCheckoutModule')
		.controller('CheckoutTrustProfileForm', [
			'$filter',
			'FileUploadFactory',
			'globalConfig',
			'US_STATES',
			CheckoutTrustProfileFormFunction
		]);

	function CheckoutTrustProfileFormFunction(
		$filter,
		FileUploadFactory,
		globalConfig,
		US_STATES) {
		
		var checkout = this;
		
		checkout.formValues = globalConfig.formValues;
		checkout.states = US_STATES;
		checkout.trustClassifications = globalConfig.trustClassifications;
		checkout.trustTypes = globalConfig.trustTypes;
		checkout.irrevocableTrustSubtypes = globalConfig.irrevocableTrustSubtypes;
		checkout.tinTypes = globalConfig.tinTypes;
		checkout.formValues.trustClassification = $filter('findSelectedOption')(checkout.formValues.trustClassification, 'value', checkout.trustClassifications);
		checkout.formValues.trustType = $filter('findSelectedOption')(checkout.formValues.trustType, 'value', checkout.trustTypes);
		checkout.formValues.irrevocableTrustSubtype = $filter('findSelectedOption')(checkout.formValues.irrevocableTrustSubtype, 'value', checkout.irrevocableTrustSubtypes);
		checkout.formValues.registrationState = $filter('findSelectedOption')(checkout.formValues.registrationState, 'abbreviation', checkout.states);
		checkout.formValues.state = $filter('findSelectedOption')(checkout.formValues.state, 'abbreviation', checkout.states);
		checkout.formValues.tinType = $filter('findSelectedOption')(checkout.formValues.tinType, 'value', checkout.tinTypes);

		checkout.trust = FileUploadFactory.createStateObj('IDENTIFICATION_DOCUMENT');
		checkout.resetUpload = FileUploadFactory.resetUpload;
		checkout.uploadFiles = FileUploadFactory.uploadFiles;
	}
})(window.angular);